export const PTO_ENABLED_SET = "systemSettings/PTO_ENABLED_SET"
export const PTO_MINIMAL_VALUE_SET = "systemSettings/PTO_MINIMAL_VALUE_SET"
export const PTO_USER_EXCEPTION_TYPE_SET = "systemSettings/PTO_USER_EXCEPTION_TYPE_SET"
export const PTO_EXCEPTION_USERS_SET = "systemSettings/PTO_EXCEPTION_USERS_SET"


// WEBPACK FOOTER //
// ./web/js/administration/lowBalanceSettings/pto/actionTypes.js